import { FC } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { Box, Flex, Grid, Img } from '@chakra-ui/react';
import { UserInPeriodLeaderboard } from 'models';
import routes from 'routes';
import { formatNumberWithCommas } from 'utils/formatNumberWithCommas';
import { stylizeText } from 'utils/stylizeText';

import ParticipantPosition from './ParticipantPosition';

type Props = {
  participant: UserInPeriodLeaderboard;
  position: number;
  isMe?: boolean;
};

const LeaderboardPeriodRow: FC<Props> = ({ participant, position, isMe = false }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { period, date } = useParams();

  const friends = searchParams.get('friends') === 'true';

  const user = participant.user;

  return (
    <>
      <Box
        p="8px 0"
        borderBottom="1px solid rgba(255, 255, 255, 0.03)"
        cursor="pointer"
        transition="all 0.2s ease-in-out"
        backgroundColor={isMe ? '#F83C3C' : 'transparent'}
      >
        <Grid
          gap="10px"
          alignItems="flex-start"
          justifyContent="space-between"
          gridTemplateColumns="28px 1fr"
          px="15px"
        >
          <Flex
            align="center"
            flexBasis="100%"
            maxW="28px"
            fontWeight="400"
            lineHeight="1"
            fontFamily="Special Gothic Expanded One"
            h="100%"
          >
            <ParticipantPosition position={position + 1} isMe={isMe} />
          </Flex>
          <Flex
            gap="12px"
            align="center"
            fontSize={position < 3 ? '14px' : '12px'}
            fontWeight="800"
            lineHeight="16.94px"
            flexShrink="0"
            flexGrow="0"
            flexBasis="286px"
          >
            <Flex
              flex="1"
              align="center"
              gap="10px"
              w="100%"
              justifyContent="flex-start"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`${routes.profile}/${user.id}`, {
                  state: {
                    from: `/leaderboard/${period}/${date}?friends=${!!friends}&league=all`,
                  },
                });
              }}
              borderRadius="12px"
              cursor="pointer"
              transition="all 0.2s ease-in-out"
              _active={{ backgroundColor: 'rgba(255,255,255,0.05)' }}
            >
              <Flex
                w={position < 3 ? '40px' : '32px'}
                h={position < 3 ? '40px' : '32px'}
                borderRadius={position < 3 ? '10px' : '8px'}
                background={isMe ? '#FFFFFF' : '#FFFFFF1A'}
                justify="center"
                align="center"
                color={isMe ? '#000000' : '#FFFFFFCC'}
                flexShrink="0"
                textTransform="uppercase"
                backgroundPosition="center center"
                backgroundSize="cover"
                backgroundImage={user.avatarUrl ? `url(${user.avatarUrl})` : undefined}
              >
                {user.avatarUrl ? null : user.username[0]}
              </Flex>
              <Box
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                overflow="hidden"
                fontSize={position < 3 ? '13px' : '11px'}
                fontWeight="400"
                lineHeight="1"
                fontFamily="Special Gothic Expanded One"
                textTransform="uppercase"
              >
                {stylizeText(user.username)}
              </Box>
            </Flex>
            <Flex
              align="center"
              gap="2px"
              fontSize={position < 3 ? '14px' : '12px'}
              fontWeight="400"
              lineHeight="1"
              fontFamily="Special Gothic Expanded One"
            >
              {formatNumberWithCommas(participant.points ?? 0)}
              {/* <Img w="20px" h="20px" src="/coin.png" /> */}
            </Flex>
          </Flex>
        </Grid>
      </Box>
    </>
  );
};

export default LeaderboardPeriodRow;
